import { defineMessage } from 'services/localization';

export const messages = {
    buttonSync: defineMessage('sync'),
    inProgressStatusText: defineMessage('sync_in_progress'),
    errorStatusText: defineMessage('error'),
};
